$(function(){
if ($(".layers-mattress-holder").length) {
  	$(".layers-mattress-holder .layers-content").click(function() {
      $(".layers-mattress-holder .layers-content").removeClass('active-layer layer-up');
      $(this).addClass('active-layer layer-up');
      $('.layers-content').removeClass('layers-content-active');

      if ($('.layer1').hasClass('active-layer')) {
        $('.layers-content1').addClass('layers-content-active');
      }

      if ($('.layer2').hasClass('active-layer')) {
        $('.layers-content2').addClass('layers-content-active');
      }

      if ($('.layer3').hasClass('active-layer')) {
        $('.layers-content3').addClass('layers-content-active');
      }

      if ($('.layer4').hasClass('active-layer')) {
        $('.layers-content4').addClass('layers-content-active');
      }
  	});
    
    $(".layers-mattress-holder .layers-content").on('mouseover', function() {
      $('.layers-content-holder .layers-content').removeClass('layers-content-active');
      var index = $(this).index();
      $('.layers-content-holder .layers-content'+index).addClass('layers-content-active')
    });
    
    $(".layer0").on('mouseover', function() {
      $('.layers-content-holder .layers-content').removeClass('layers-content-active');
      $('.layers-content-holder .layers-content5').addClass('layers-content-active');
    });
    
  }
  });